import "antd/dist/antd.css";
import {
  //useContractLoader,
  useUserProviderAndSigner,
} from "eth-hooks";
import React, { useCallback, useEffect, useState } from "react";
/*
import {
  Route,
  Switch,
  useLocation
} from "react-router-dom";*/
import { Header } from "./components";
import { NETWORKS } from "./constants";
import deployedContracts from "./contracts/hardhat_contracts.json";
import externalContracts from "./contracts/external_contracts";
import {
  Web3ModalSetup,
  //Transactor,
} from "./helpers";
import MintPage from "./views/MintPage";

import "./App.scss";

const { ethers } = require("ethers");

// 📡 What chain are your contracts deployed to?
const initialNetwork = NETWORKS.mainnet; // <------- select your target frontend network (localhost, rinkeby, xdai, mainnet)

// 😬 Sorry for all the console logging
const DEBUG = false;

let web3Modal;

function App(props) {
  // specify all the chains your app is available on. Eg: ['localhost', 'mainnet', ...otherNetworks ]
  // reference './constants.js' for other networks
  const networkOptions = [initialNetwork.name, "mainnet", "rinkeby"];

  const [injectedProvider, setInjectedProvider] = useState();
  const [address, setAddress] = useState();
  //const [writeContracts, setWriteContracts] = useState({});
  const selectedNetwork = networkOptions[0];
  //const location = useLocation();

  const targetNetwork = NETWORKS[selectedNetwork];

  // 🔭 block explorer URL
  const blockExplorer = targetNetwork.blockExplorer;

  if (DEBUG) console.log(`Using ${selectedNetwork} network`);

  const logoutOfWeb3Modal = async () => {
    await web3Modal.clearCachedProvider();
    if (injectedProvider && injectedProvider.provider && typeof injectedProvider.provider.disconnect == "function") {
      await injectedProvider.provider.disconnect();
    }
    setTimeout(() => {
      window.location.reload();
    }, 1);
  };

  // Use your injected provider from 🦊 Metamask or if you don't have it then instantly generate a 🔥 burner wallet.
  const userProviderAndSigner = useUserProviderAndSigner(injectedProvider);  
  const userSigner = userProviderAndSigner.signer;

  useEffect(() => {
    async function getAddress() {
      if (userSigner) {
        const newAddress = await userSigner.getAddress();
        setAddress(newAddress);
      }
    }
    getAddress();
  }, [userSigner]);

  // You can warn the user if you would like them to be on a specific network
  //const localChainId = localProvider && localProvider._network && localProvider._network.chainId;
  const selectedChainId =
    userSigner && userSigner.provider && userSigner.provider._network && userSigner.provider._network.chainId;

  let BlueCheckmark;
  let writeContracts = {};
  if(
    deployedContracts[selectedChainId] &&
    deployedContracts[selectedChainId][selectedNetwork] &&
    deployedContracts[selectedChainId][selectedNetwork].contracts &&
    deployedContracts[selectedChainId][selectedNetwork].contracts.BlueCheckmark
  ) {
    const contractInfo = deployedContracts[selectedChainId][selectedNetwork].contracts.BlueCheckmark;
    BlueCheckmark = new ethers.Contract(contractInfo.address, contractInfo.abi, userSigner);
  }
  writeContracts = {
    BlueCheckmark
  };

  if(
    externalContracts[selectedChainId] &&
    externalContracts[selectedChainId].contracts
  ) {
    const entries = Object.entries(externalContracts[selectedChainId].contracts);
    entries.forEach(([_contractName, contractInfo]) => {
      contractInfo.contract = new ethers.Contract(contractInfo.address, contractInfo.abi, userSigner);

      writeContracts = {
        ...writeContracts,
        [_contractName]: contractInfo,
      }
    });
  }

  //
  // 🧫 DEBUG 👨🏻‍🔬
  //
  useEffect(() => {
    if (
      DEBUG &&
      address &&
      selectedChainId
    ) {
      console.log("_____________________________________ 🏗 scaffold-eth _____________________________________");
      //console.log("🏠 localChainId", localChainId);
      console.log("👩‍💼 selected address:", address);
      console.log("🕵🏻‍♂️ selectedChainId:", selectedChainId);
    }
  }, [
    address,
    selectedChainId,
    //localChainId,
  ]);

  const loadWeb3Modal = useCallback(async () => {
    const provider = await web3Modal.connect();
    setInjectedProvider(new ethers.providers.Web3Provider(provider));

    provider.on("chainChanged", chainId => {
      setInjectedProvider(new ethers.providers.Web3Provider(provider));
    });

    provider.on("accountsChanged", () => {
      setInjectedProvider(new ethers.providers.Web3Provider(provider));
    });

    // Subscribe to session disconnection
    provider.on("disconnect", (code, reason) => {
      logoutOfWeb3Modal();
    });
    // eslint-disable-next-line
  }, [setInjectedProvider]);

  useEffect(() => {
    if(!web3Modal) {
      web3Modal = Web3ModalSetup()
    }
    if (web3Modal.cachedProvider) {
      loadWeb3Modal();
    }
  }, [loadWeb3Modal]);

  return (
    <div className="App">
      <div className="container">
        <Header
          address={address}
          userSigner={userSigner}
          web3Modal={web3Modal}
          loadWeb3Modal={loadWeb3Modal}
          logoutOfWeb3Modal={logoutOfWeb3Modal}
          blockExplorer={blockExplorer}
        />
        <div className="content">
          <MintPage
            address={address}
            //readContracts={readContracts}
            writeContracts={writeContracts}
            onClickConnect={loadWeb3Modal}
            blockExplorer={blockExplorer}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
